import $ from "jquery";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import UserImageLogo_bg from "../../images/UserImageLogo_bg.jpg";
import AlertModal from "../CommonControlls/AlertModal";
import * as Common from "../CommonControlls/CommonJs";
import DropDown from "../CommonControlls/DropdownRendrer";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import { SyncConfig } from "../OfflineDb/ConfigDataSync";

const mapStateToProps = (store) => {
	return store;
};

const mapDispatchToProps = (dispatch) => {
	return {
		ShowAlert: (Settings) => {
			dispatch({ type: "UpdateAlert", payload: Settings });
		},
		ShowLoader: (Isloading) => {
			dispatch({ type: "UpdateLoader", payload: Isloading });
		},
	};
};

class Users_Add extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loggedinUser: 0,
			Id: 0,
			isImageUpdated: false,
			isActive: true,
			UserImageLogo: UserImageLogo_bg,
			imageURL: "",
			imageURLBase64: null,

			//Roles
			RolesLoader: false,
			Roleslist: [],
			RoleId: 0,

			RiderTypes: [
				{ id: "cvr", name: "CVR" },
				{ id: "publicServant", name: "Public Servant" },
				{ id: "privateServant", name: "Private Servant" },
				{ id: "projectStaff", name: "Project Staff" },
				{ id: "fr", name: "Fixed Rider" },
			],
			riderTypeId: null,

			HCFLoader: false,
			BHUList: [],
			RHCList: [],
			BHUId: 0,
			RHCId: 0,

			XpertSiteLoader: false,
			XpertSitelist: [],
			FilteredXpertSites: [],
			XpertSiteId: 0,

			FilteredSrs: [],
			SrList: [],
			SrId: [],

			DistrictLoader: false,
			Districtlist: [],
			DistrictId: 0,

			FilteredAllowedDistricts: [],

			alertModalData: {
				title: "",
				message: "",
				First_Callback: () => {},
				Second_Callback: () => {},
				type: 1,
			},

			ProvinceLoader: false,
			Provincelist: [],
			ProvinceId: 0,

			FilteredDistrictlist: [],
			AddressDistrictId: 0,

			TehsilLoader: false,
			Tehsillist: [],
			FilteredTehsillist: [],
			TehsilId: 0,

			SelectedProvince: [],

			SRDistrictId: [],

			CompleteDistrictlist: [],

			saveddistictId: 0,

			Banklist: [],
			BankId: 0,
			BankLoader: false,

			FilteredRHC: [],
			FilteredBHU: [],

			ClustersList: [],
			FilteredClustersList: [],
			ClusterId: [],
			ClusterLoader: false,
			savedClusterId: null,
		};
	}

	componentWillMount() {
		if (this.props.UserAuthentication.AuthToken === "") {
			this.props.history.push("/Login");
		}

		Common.parseJwt(this.props.UserAuthentication.AuthToken, (user) => {
			this.setState({
				loggedinUser: user.id,
			});
		});
	}

	componentDidMount() {
		// Common.AddClassToMenueLink("MenuLink_Users",true,"MenuParentLink_Security")
		Common.AddClassToMenueLink("MenuLink_Users");
		$("#UploadImgBtn").change((e) => {
			this.setState({
				isImageUpdated: true,
			});
			for (var i = 0; i < e.originalEvent.srcElement.files.length; i++) {
				var file = e.originalEvent.srcElement.files[i];
				var reader = new FileReader();
				reader.onloadend = function () {
					$("#Upload_ImageDropZone").attr("src", reader.result);
					$("#Upload_ImageDropZone").show();
				};
				reader.readAsDataURL(file);
			}
		});

		var Id = Common.GetId();
		this.GetPageConfigData(Id, () => {
			if (Id !== 0) {
				this.selectUser(Id);
				Common.Ajax(
					this.props.UserAuthentication.AuthToken,
					"GET",
					false,
					Common.BaseUrlAPI + `/api/UserAllowedDistricts/SelectAll`,
					{ userId: Id },
					(resp) => {
						const commaSeperated = Common.ConvertToCommaSplitArray(
							resp.data,
							"districtId"
						);
						const allowed = this.state.Districtlist.filter(
							(d) => commaSeperated.indexOf(d.id) > -1
						);
						this.setState({
							SRDistrictId: allowed,
						});
					},
					(error) => {
						this.props.ShowAlert({ Type: 0, Msg: error });
						setTimeout(function () {
							$("#Alertmsgbtn").click();
						}, 50);
					}
				);
			}
		});

		// this.SelectSubReciepents()
	}

	HandleAutoSuggestValChange = (fieldId, value) => {
		this.setState({ [fieldId]: value }, () => {
			if (fieldId === "ProvinceId") {
				this.SelectDistricts(value);
			}
			if (fieldId === "SrId") {
				const tempDistricts = this.state.Districtlist;
				var selectedSrs = this.state.SrId;

				var filteredSrsId = Common.ConvertToCommaSplitArray(selectedSrs, "id");

				var filteredSelectedDistricts = tempDistricts.filter(function (obj) {
					return filteredSrsId.indexOf(obj.subrecipientid) > -1;
				});

				this.setState({
					FilteredAllowedDistricts: filteredSelectedDistricts,
				});
			}
			if (fieldId === "AddressDistrictId") {
				this.SelectTehsil(value);
				const TempArr = this.state.Tehsillist;
				const filteredArr = TempArr.filter(function (obj) {
					return obj.districtId === value;
				});

				const TempBHU = this.state.BHUList;
				const filteredBHU = TempBHU.filter(
					(item) => +item.districtId === value
				);

				const TempRHC = this.state.RHCList;
				const filteredRHC = TempRHC.filter(
					(item) => +item.districtId === value
				);

				const TempXpert = this.state.XpertSitelist;
				const filteredXpert = TempXpert.filter(
					(item) => +item.districtId === value
				);
				this.setState({
					FilteredTehsillist: filteredArr,
					FilteredBHU: filteredBHU,
					FilteredRHC: filteredRHC,
					FilteredXpertSites: filteredXpert,
				});
			}
			if (fieldId === "DistrictId") {
				const TempClustersList = this.state.ClustersList;
				const filteredClustersList = TempClustersList.filter(function (obj) {
					return obj.districtId === value;
				});

				const selectedCluster = this.state.ClusterId;
				const filteredClusterIdArr = Common.ConvertToCommaSplitArray(
					filteredClustersList,
					"id"
				);
				const filteredSelectedCluster = selectedCluster.filter(function (obj) {
					return filteredClusterIdArr.indexOf(obj.id) > -1;
				});

				this.setState({
					FilteredClustersList: filteredClustersList,
					ClusterId: filteredSelectedCluster,
				});
			}

			if (fieldId === "RoleId") {
				if (
					(value !== 0 ||
						value !== 4 ||
						value !== 7 ||
						value !== 3 ||
						value !== 6) &&
					this.state.SrList?.length === 0
				) {
					this.SelectSubReciepents();
				}
				if (value === 3 && this.state.XpertSitelist?.length === 0) {
					this.SelectXpertSites();
				}

				if ((value === 6 || value === 7) && this.state.BHUList?.length === 0) {
					this.SelectHCF();
				}
			}
		});
	};

	handleChange = (fieldId, value) => {
		if (fieldId === "SelectedProvince") {
			var selectedProvince = Common.ConvertToCommaSplitArray(value, "id");
			const tempSrs = this.state.SrList;
			const filteredSrs = tempSrs.filter(
				(item) => selectedProvince.indexOf(item.provinceid) > -1
			);
			this.setState({
				FilteredSrs: filteredSrs,
			});
		}
	};

	GetPageConfigData = (Id, CallBack) => {
		this.props.ShowLoader({ Isloading: true });
		var d1 = $.Deferred();
		var d2 = $.Deferred();
		var d3 = $.Deferred();
		var d4 = $.Deferred();
		var d5 = $.Deferred();
		var d6 = $.Deferred();
		var d7 = $.Deferred();
		var d8 = $.Deferred();
		var d9 = $.Deferred();
		this.SelectRoles(() => {
			d1.resolve();
		});
		// this.SelectXpertSites(() => {
		//   d2.resolve()
		// })
		// this.SelectHCF(() => {
		//   d3.resolve()
		// })
		// this.SelectDistricts(() => {
		//   d4.resolve()
		// })
		this.SelectProvinces(() => {
			d5.resolve();
		});
		// this.SelectTehsil(() => {
		//   d6.resolve()
		// })
		// this.SelectCompleteDistricts(() => {
		//     d7.resolve()
		// })
		this.SelectAllBanksList(() => {
			d8.resolve();
		});
		this.SelectDFSClusters(Id, () => {
			d9.resolve();
		});
		$.when(d1, d5, d8, d9).done(() => {
			this.props.ShowLoader({ Isloading: false });
			CallBack();
		});
	};
	SelectRoles = (Callback) => {
		this.setState({ RolesLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Role,
			{},
			(data) => {
				this.setState({
					RolesLoader: false,
					Roleslist: data.data,
				});
				Callback();
			},
			(error) => {
				this.setState({ RolesLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectXpertSites = () => {
		this.setState({ XpertSiteLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_XpertSites,
			{},
			(response) => {
				const TempXpert = response.data;
				const filteredXpert = TempXpert.filter(
					(item) => +item.districtId === +this.state.AddressDistrictId
				);
				this.setState({
					FilteredXpertSites: filteredXpert,
					XpertSiteLoader: false,
					XpertSitelist: response.data,
				});
			},
			(error) => {
				this.setState({ XpertSiteLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	SelectSubReciepents = () => {
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectALl_SubRecipient,
			{},
			(resp) => {
				if (resp.status) {
					this.setState({
						SrList: resp.data.map((d) => ({
							id: d.id,
							name: d.short_name,
							districtId: d.districtid,
							...d,
						})),
					});
				}
			}
		);
	};
	SelectHCF = () => {
		this.setState({ HCFLoader: true });
		Common.Ajax(
			this.props.UserAuthentication?.AuthToken,
			"GET",
			false,
			Common.APILinks.GetAll_HCF,
			{},
			(data) => {
				var BHUList = [];
				var RHCList = [];
				for (var i = 0; i < data.data.length; i++) {
					if (data.data[i].typeId === 1) {
						BHUList.push(data.data[i]);
					} else {
						RHCList.push(data.data[i]);
					}
				}

				const TempBHU = BHUList;
				const filteredBHU = TempBHU.filter(
					(item) => +item.districtId === +this.state.AddressDistrictId
				);

				const TempRHC = RHCList;
				const filteredRHC = TempRHC.filter(
					(item) => +item.districtId === +this.state.AddressDistrictId
				);

				this.setState({
					FilteredBHU: filteredBHU,
					FilteredRHC: filteredRHC,
					HCFList: data.data,
					BHUList: BHUList,
					RHCList: RHCList,
					HCFLoader: false,
				});
			},
			(error) => {
				this.setState({ HCFLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	SelectProvinces = (Callback) => {
		this.setState({ ProvinceLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Province,
			{ isPaginate: false },
			(data) => {
				this.setState({
					ProvinceLoader: false,
					Provincelist: data.data,
				});
				Callback();
			},
			(error) => {
				this.setState({ ProvinceLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectDistricts = (provinceId) => {
		this.setState({ DistrictLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_District,
			{},
			(response) => {
				const tempDistricts = response.data;
				const filteredDistricts = tempDistricts.filter(
					(item) => item.provinceId === provinceId
				);
				this.setState({
					Districtlist: response.data,
					FilteredDistrictlist: filteredDistricts,
					DistrictLoader: false,
				});
			},
			(error) => {
				this.setState({ DistrictLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	SelectTehsil = (districtId) => {
		this.setState({ TehsilLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Tehsil,
			{},
			(response) => {
				const TempArr = response.data;
				const filteredArr = TempArr.filter(function (obj) {
					return obj.districtId === districtId;
				});
				this.setState({
					FilteredTehsillist: filteredArr,
					TehsilLoader: false,
					Tehsillist: response.data,
				});
			},
			(error) => {
				this.setState({ TehsilLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	selectUser = (Id) => {
		this.props.ShowLoader({ Isloading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.Select_User,
			{ Id: Id },
			(resp) => {
				this.props.ShowLoader({ Isloading: false });
				if (resp.status) {
					this.LoadDataInEditMode(resp.data);
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(() => {
						$("#Alertmsgbtn").click();
					}, 50);
					if (resp.message === "No record found.") $("#Form_CancelBtn").click();
				}
			},
			(error) => {
				this.props.ShowLoader({ Isloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wronge, please try again.",
				});
				setTimeout(() => {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	SelectAllBanksList = (Callback) => {
		this.setState({ BankLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Bank,
			{},
			(data) => {
				this.setState({
					BankLoader: false,
					Banklist: data.data,
				});
				Callback();
			},
			(error) => {
				this.setState({ BankLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectDFSClusters = (Id, Callback) => {
		this.setState({ ClusterLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.SelectUnAssigned_Clusters,
			{ userId: Id },
			(Result) => {
				if (Result.status === true) {
					this.setState({
						ClustersList: Result.data,
						ClusterLoader: false,
					});
				} else {
					this.setState({ ClusterLoader: false });
					this.props.ShowAlert({ Type: 0, Msg: Result.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				Callback();
			},
			(error) => {
				this.setState({ ClusterLoader: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wronge, please try again",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	LoadDataInEditMode = (data) => {
		// var selectedSRDistrict = []

		// if (data.srDistrictIds !== null ||  data.srDistrictIds !== "0") {
		//     var srDistrictIds = data.srDistrictIds.split(",")
		//     srDistrictIds.shift()
		//     srDistrictIds.pop()
		//     var ProcessedDistrict = Common.ProcessDataInArray(this.state.Districtlist, "id")
		//     for (var i in srDistrictIds) {
		//         if (ProcessedDistrict[srDistrictIds[i]] !== undefined)
		//             selectedSRDistrict.push(ProcessedDistrict[srDistrictIds[i]])
		//     }
		// }

		// if (this.state.SRDistrictId.length > 0) {
		//     var srids = Common.ConvertToCommaSplitArray(this.state.SRDistrictId, 'id')
		//     console.log({srids})
		//     var srDistrictIds = srids.split(",")
		//         srDistrictIds.shift()
		//         srDistrictIds.pop()
		//     var ProcessedDistrict = Common.ProcessDataInArray(this.state.Districtlist, "id")
		//     for (var i in srDistrictIds) {
		//         if (ProcessedDistrict[srDistrictIds[i]] !== undefined)
		//             selectedSRDistrict.push(ProcessedDistrict[srDistrictIds[i]])
		//     }
		// }

		var selectedClusters = [];
		if (
			data.role === 5 &&
			data.dfsAssignedClusters != null &&
			data.dfsAssignedClusters !== ""
		) {
			var dfsAssignedClusters = data.dfsAssignedClusters.split(",");
			dfsAssignedClusters.shift();
			dfsAssignedClusters.pop();
			var ProcessedClustersList = Common.ProcessDataInArray(
				this.state.ClustersList,
				"id"
			);
			for (var i in dfsAssignedClusters) {
				if (ProcessedClustersList[dfsAssignedClusters[i]] !== undefined)
					selectedClusters.push(ProcessedClustersList[dfsAssignedClusters[i]]);
			}
		}
		const district = this.state.Districtlist.find(
			(item) => item.id === data.addressDistrictId
		);
		const sr = this.state.SrList.filter(
			(item) => item.id === district.subrecipientid
		);

		setTimeout(() => {
			this.setState({
				Id: data.id,
				isImageUpdated: false,
				isActive: data.isActive,
				BHUId: data.role === 6 ? data.hcfId : 0,
				RHCId: data.role === 7 ? data.hcfId : 0,
				XpertSiteId: data.xpertSiteId,
				SrId: sr.id,
				DistrictId: data.districtId,
				saveddistictId: data.districtId,
				savedClusterId: data.dfsAssignedClusters,
				imageURL: data.imageURL,
				SRDistrictId: this.state.SRDistrictId,
				ProvinceId: data.addressProvinceId,
				AddressDistrictId: data.addressDistrictId,
				TehsilId: data.addressTehsilId,
				ClusterId: selectedClusters,
				imageURLBase64: data.imageURLBase64 === "" ? null : data.imageURLBase64,
				BankId: data.bankId,
				riderTypeId: data.ridertype,
			});
		}, 5000);

		$("#UserName").val(data.name);
		$("#UserPhone").val(data.contact);
		$("#UserEmail").val(data.email);
		$("#UserPassword").val(data.password);
		$("#UserAddress").val(data.address);
		$("#VehicleNumber").val(data.vehicleNumber);
		$("#VehicleModel").val(data.vehicleModel);
		$("#AccountNumber").val(data.accountNumber);
		$("#cnic").val(data.cnic);
		$("#Upload_ImageDropZone").attr(
			"src",
			data.imageURLBase64 === "" || data.imageURLBase64 === null
				? ""
				: data.imageURLBase64
		);
		if (data.imageURLBase64 !== "" && data.imageURLBase64 != null)
			$("#Upload_ImageDropZone").show();
	};
	ResetForm = () => {
		this.setState({
			Id: 0,
			isImageUpdated: false,
			isActive: true,
			BHUId: 0,
			RHCId: 0,
			XpertSiteId: 0,
			DistrictId: 0,
			imageURL: "",
			ProvinceId: 0,
			AddressDistrictId: 0,
			TehsilId: 0,
			SRDistrictId: [],
			imageURLBase64: null,
			BankId: 0,
			savedClusterId: null,
			saveddistictId: 0,
			ClusterId: [],
		});
		$("#UserName").val("");
		$("#UserPhone").val("");
		$("#UserEmail").val("");
		$("#UserPassword").val("");
		$("#UserAddress").val("");
		$("#UploadImgBtn").val("");
		$("#VehicleNumber").val("");
		$("#VehicleModel").val("");
		$("#AccountNumber").val("");
		$("#Upload_ImageDropZone").attr("src", "");
		$("#Upload_ImageDropZone").hide();
	};
	SubmitForm = (e) => {
		e.preventDefault();
		if (this.state.ProvinceId === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select province" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		if (this.state.AddressDistrictId === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select user district" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		if (this.state.TehsilId === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select tehsil" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		if (this.state.RoleId === 3 && this.state.XpertSiteId === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select Xpert Site" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}

		//this.state.RoleId === 4 && 
		if (!this.state.riderTypeId) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select User Type" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}

		if (this.state.RoleId === 5 && this.state.DistrictId === 0) {
			this.props.ShowAlert({
				Type: 0,
				Msg: "Please select supervisor district",
			});
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		if (this.state.RoleId === 5 && this.state.ClusterId.length === 0) {
			this.props.ShowAlert({
				Type: 0,
				Msg: "Please select supervisor cluster",
			});
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		if (this.state.RoleId === 6 && this.state.BHUId === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select BHU" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		// if (this.state.RoleId === 8 && this.state.RHCId === 0) {
		//     this.props.ShowAlert({Type: 0, Msg: "Please select RHC"})
		//     setTimeout(function () {
		//         $("#Alertmsgbtn").click()
		//     }, 50);
		//     return
		// }
		// if(this.state.RoleId==8 && this.state.SRDistrictId.length==0)
		// {
		//     this.props.ShowAlert({Type:0,Msg: "Please select SR admin districts"})
		//     setTimeout(function(){ $("#Alertmsgbtn").click()}, 50);
		//     return
		// }

		if (
			(this.state.RoleId === 3 ||
				this.state.RoleId === 4 ||
				this.state.RoleId === 5 ||
				this.state.RoleId === 6 ||
				this.state.RoleId === 7) &&
			this.state.BankId === 0
		) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select Bank" });

			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}

		const hasSpaceOrSpecialChar = (str) => {
			// regular expression pattern to match spaces or special characters
			const pattern = /[\s~`!@#$%^&*()_\-+={[}\]|\\:;"'<,>.?/]/;
			// check if the string contains a space or special character
			return pattern.test(str);
		};

		const accountNumber = $("#AccountNumber").val();
		const cnic = $("#cnic").val();

		if (accountNumber) {
			if (hasSpaceOrSpecialChar(accountNumber)) {
				this.props.ShowAlert({
					Type: 0,
					Msg: "Account Number should not have special characters or spaces",
				});

				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				return;
			}

			if (accountNumber.length !== 24) {
				this.props.ShowAlert({
					Type: 0,
					Msg: "Account Number should be of length 24",
				});

				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				return;
			}
		}

		if (cnic) {
			//if (hasSpaceOrSpecialChar(cnic)) {
			//	this.props.ShowAlert({
			//		Type: 0,
			//		Msg: "CNIC should not have special characters or spaces",
			//	});

			//	setTimeout(function () {
			//		$("#Alertmsgbtn").click();
			//	}, 50);
			//	return;
			//}

			if (cnic.length !== 15) {
				this.props.ShowAlert({
					Type: 0,
					Msg: "CNIC should be of length 15",
				});

				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				return;
			}
		}

		// Common.encodeImgtoBase64("UploadImgBtn", (imageURLBase64) => {
		this.props.ShowLoader({ Isloading: true });
		var srDistrictIds = "";
		if (this.state.SRDistrictId.length > 0) {
			srDistrictIds =
				"," + Common.convertToCommaString(this.state.SRDistrictId, "id") + ",";
		}

		var dfsAssignedClusters = "";
		if (this.state.ClusterId.length > 0) {
			dfsAssignedClusters =
				"," + Common.convertToCommaString(this.state.ClusterId, "id") + ",";
		}

		// var provinceIdString = this.state.ProvinceId.length === 0 ? "" : ("," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",")

		const formData = {
			imageURLBase64: this.state.isImageUpdated
				? this.state.imageURLBase64
				: "",
			hcfId:
				this.state.RoleId === 6
					? this.state.BHUId
					: this.state.RoleId === 7
					? this.state.RHCId
					: 0,
			id: this.state.Id,
			xpertSiteId: this.state.XpertSiteId ? this.state.XpertSiteId : 0,
			isActive: this.state.isActive,
			vehicleNumber: $("#VehicleNumber").val()
				? $("#VehicleNumber").val()
				: "0",

			accountNumber:
				this.state.RoleId === 1 ||
				this.state.RoleId === 13 ||
				this.state.RoleId === 8 ||
				this.state.RoleId === 11 ||
				this.state.RoleId === 14 ||
				this.state.RoleId === 15 ||
				this.state.RoleId === 16
					? 0
					: accountNumber,

			bankId:
				this.state.RoleId === 1 ||
				this.state.RoleId === 13 ||
				this.state.RoleId === 8 ||
				this.state.RoleId === 11 ||
				this.state.RoleId === 14 ||
				this.state.RoleId === 15 ||
				this.state.RoleId === 16
					? 0
					: this.state.BankId,

			dfsAssignedClusters: this.state.RoleId === 5 ? dfsAssignedClusters : "0",
			vehicleModel: $("#VehicleModel").val() ? $("#VehicleModel").val() : "0",
			srDistrictIds: srDistrictIds ? srDistrictIds : "0",
			role: this.state.RoleId,
			districtId:
				this.state.RoleId === 5 ||
				this.state.RoleId === 7 ||
				this.state.RoleId === 6 ||
				this.state.RoleId === 4 ||
				this.state.RoleId === 3
					? this.state.DistrictId
					: 0,
			addressProvinceId: this.state.ProvinceId,
			addressTehsilId: this.state.TehsilId,
			addressDistrictId: this.state.AddressDistrictId,
			name: $("#UserName").val(),
			contact: $("#UserPhone").val(),
			email: $("#UserEmail").val(),
			password: $("#UserPassword").val(),
			cnic,
			gender: $("#gender").val(),
			filingStatus: $("#filingStatus").val(),
			riderType: this.state.riderTypeId,//his.state.RoleId === 4 ? this.state.riderTypeId : null
		};
		// var formData = new FormData();
		// if(this.state.isImageUpdated)
		// {
		//     var ins = $('#UploadImgBtn')[0].files.length;
		//     for (var x = 0; x < ins; x++) {
		//       formData.append("files", $('#UploadImgBtn')[0].files[x])
		//     }
		// }
		// else
		// {
		//     formData.append('files',null);
		// }
		// formData.append('name', $("#UserName").val());
		// formData.append('contact', $("#UserPhone").val());
		// formData.append('email', $("#UserEmail").val());
		// formData.append('address', $("#UserAddress").val());
		// formData.append('password', $("#UserPassword").val());
		// formData.append('cnic', $("#cnic").val());
		// formData.append('id', this.state.Id);
		// formData.append('hcfId', this.state.RoleId === 6 ? this.state.BHUId : this.state.RoleId === 7 ? this.state.RHCId : '0');
		// formData.append('xpertSiteId', this.state.RoleId === 3 ? this.state.XpertSiteId : '0');
		// formData.append('districtId', this.state.RoleId === 5 ? this.state.DistrictId : '0');
		// formData.append('role', this.state.RoleId);
		// formData.append('isActive', this.state.isActive);
		// formData.append('addressProvinceId', this.state.ProvinceId);
		// formData.append('addressDistrictId', this.state.AddressDistrictId);
		// formData.append('addressTehsilId', this.state.TehsilId);
		// formData.append('vehicleNumber', this.state.RoleId === 4 ? $("#VehicleNumber").val() : "0");
		// formData.append('vehicleModel', this.state.RoleId === 4 ? $("#VehicleModel").val() : "0");
		// formData.append('srDistrictIds', this.state.RoleId === 7 ? srDistrictIds : "0");
		// // formData.append('imageURLBase64', this.state.isImageUpdated ? imageURLBase64 : this.state.imageURLBase64);
		// formData.append('accountNumber', this.state.RoleId === 4 ? $("#AccountNumber").val() : "0");
		// formData.append('bankId', this.state.RoleId === 4 ? this.state.BankId : "0");
		// formData.append('gender', $('#gender').val());
		// // formData.append('PrevimageURL', this.state.imageURL==null?"":this.state.imageURL);
		// formData.append('dfsAssignedClusters', this.state.RoleId === 5 ? dfsAssignedClusters : "0");

		const allowedDistrict =
			this.state.RoleId === 6 ||
			this.state.RoleId === 7 ||
			this.state.RoleId === 3 ||
			this.state.RoleId === 4
				? [{ districtId: this.state.AddressDistrictId }]
				: this.state.SRDistrictId.map((item) => ({ districtId: item.id }));

		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			this.state.Id === 0
				? Common.APILinks.Save_User
				: Common.APILinks.Update_User,
			JSON.stringify(formData),
			(resp) => {
				if (resp.status) {
					Common.Ajax(
						this.props.UserAuthentication.AuthToken,
						"POST",
						false,
						Common.BaseUrlAPI +
							"/api/UserAllowedDistricts/InsertUserAllowedDistricts",
						JSON.stringify({
							userAllowedDistrictsModel: allowedDistrict,
							userId: this.state.Id !== 0 ? this.state.Id : resp.data.id,
						}),
						(resp) => {
							console.log(resp);
						},
						(error) => {
							console.log(error);
						}
					);
					if (this.state.RoleId === 4) {
						SyncConfig(
							() => {
								this.props.ShowLoader({ Isloading: false });
								if (this.state.Id !== 0) $("#Form_ResetBtn").click();
								this.ResetForm();
								this.props.ShowAlert({ Type: 1, Msg: "Saved successfully" });
								setTimeout(() => {
									$("#Alertmsgbtn").click();
								}, 50);
							},
							() => {
								if (this.state.Id !== 0) $("#Form_ResetBtn").click();
								this.ResetForm();
								this.props.ShowLoader({ Isloading: false });
								this.props.ShowAlert({
									Type: 0,
									Msg: "Error in sync, please reload the page",
								});
								setTimeout(function () {
									$("#Alertmsgbtn").click();
								}, 50);
							}
						);
					} else {
						this.props.ShowLoader({ Isloading: false });
						if (this.state.Id != 0) $("#Form_ResetBtn").click();
						this.ResetForm();
						this.props.ShowAlert({ Type: 1, Msg: "Saved successfully" });
						setTimeout(() => {
							$("#Alertmsgbtn").click();
						}, 50);
					}
				} else {
					this.props.ShowLoader({ Isloading: false });
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(() => {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(error) => {
				this.props.ShowLoader({ Isloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(() => {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	updatepasswordviewfun = (type) => {
		if (type === 1) {
			$("#hidepasswordlink").show();
			$("#viewpasswordlink").hide();
			$("#UserPassword").prop("type", "text");
		} else {
			$("#hidepasswordlink").hide();
			$("#viewpasswordlink").show();
			$("#UserPassword").prop("type", "password");
		}
	};
	onDelete = () => {
		this.setState(
			{
				alertModalData: {
					title: "Delete User",
					message: "Are you sure you want to delete this record.",
					First_Callback: () => {
						$("#Generic-modal-CloseBtn").click();
						this.DeleteRecord();
					},
					Second_Callback: () => {
						$("#Generic-modal-CloseBtn").click();
					},
					type: 1,
				},
			},
			() => {
				$("#Show_ArletModal").click();
			}
		);
	};
	DeleteRecord = () => {
		this.props.ShowLoader({ Isloading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.Delete_User,
			{
				id: this.state.Id,
				roleId: this.state.RoleId,
			},
			(Result) => {
				if (Result.status === true) {
					if (this.state.RoleId === 4) {
						SyncConfig(
							() => {
								$("#Form_CancelBtn").click();
								this.props.ShowLoader({ Isloading: false });
								this.props.ShowAlert({ Type: 1, Msg: "Deleted Successfully." });
								setTimeout(function () {
									$("#Alertmsgbtn").click();
								}, 50);
							},
							() => {
								this.props.ShowLoader({ Isloading: false });
								this.props.ShowAlert({
									Type: 0,
									Msg: "Error in sync, please reload the page",
								});
								setTimeout(function () {
									$("#Alertmsgbtn").click();
								}, 50);
							}
						);
					} else {
						this.props.ShowLoader({ Isloading: false });
						this.props.ShowAlert({ Type: 1, Msg: "Deleted Successfully" });
						setTimeout(function () {
							$("#Alertmsgbtn").click();
						}, 50);
						$("#Form_CancelBtn").click();
					}
				} else {
					this.props.ShowLoader({ Isloading: false });
					this.props.ShowAlert({ Type: 0, Msg: Result.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(error) => {
				this.props.ShowLoader({ Isloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wronge, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	render() {
		return (
			<div>
				<MainLayout />
				<AlertModal {...this.state.alertModalData} />
				<div id="right-panel" class="right-panel">
					<Topmenu
						PageTitle={this.state.Id === 0 ? "Add User" : "Edit User"}
						isShowAddBtn={false}
					/>
					<div class="content col-md-12 col-lg-12 d-flex justify-content-center">
						<div class="card col-md-8 col-lg-8">
							<div class="card-body row">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<form
										autocomplete="off"
										onSubmit={this.SubmitForm}
										novalidate
									>
										<div class="row">
											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label for="">
													<span style={{ color: "red" }}>* </span>Name
												</label>
												<input
													autocomplete="off"
													type="text"
													class="form-control"
													id="UserName"
													placeholder="Enter user name"
													required
												/>
											</div>

											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label for="">
													<span style={{ color: "red" }}>*</span>Phone
												</label>
												<input
													autocomplete="off"
													pattern="[0][0-9]{10}"
													type="text"
													class="form-control"
													id="UserPhone"
													placeholder="Enter user phone - 03123456789"
													required
												/>
											</div>

											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label for="">Email</label>
												<input
													autocomplete="off"
													type="email"
													class="form-control"
													id="UserEmail"
													placeholder="Enter user email"
												/>
											</div>

											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label for="">
													<span style={{ color: "red" }}>* </span>Password
												</label>
												<input
													autocomplete="off"
													type="password"
													class="form-control"
													id="UserPassword"
													placeholder="Enter user password"
													required
												/>
												<i
													id="viewpasswordlink"
													onClick={(e) => this.updatepasswordviewfun(1)}
													class="fa fa-eye viewpasswordicon"
													aria-hidden="true"
												></i>
												<i
													id="hidepasswordlink"
													onClick={(e) => this.updatepasswordviewfun(2)}
													class="fa fa-eye-slash viewpasswordicon"
													style={{ display: "none" }}
													aria-hidden="true"
												></i>
											</div>

											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label for="">
													<span style={{ color: "red" }}>* </span>Province
												</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="ProvinceId"
													options={this.state.Provincelist}
													val={this.state.ProvinceId}
													addPlaceholder=""
													disabled={false}
													loading={this.state.ProvinceLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>

											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label for="">
													<span style={{ color: "red" }}>* </span>District
												</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="AddressDistrictId"
													options={this.state.FilteredDistrictlist}
													val={this.state.AddressDistrictId}
													addPlaceholder=""
													disabled={false}
													loading={this.state.DistrictLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>

											<div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label for="">
													<span style={{ color: "red" }}>* </span>Tehsil
												</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="TehsilId"
													options={this.state.FilteredTehsillist}
													val={this.state.TehsilId}
													addPlaceholder=""
													disabled={false}
													loading={this.state.TehsilLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>

											<div
												class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12"
											>
												<label for="">
													<span style={{ color: "red" }}>* </span>
													User Type
												</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="riderTypeId"
													options={this.state.RiderTypes}
													val={this.state.riderTypeId}
													addPlaceholder=""
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>

											<div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<label for="">
													<span style={{ color: "red" }}>* </span>Role
												</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="RoleId"
													options={this.state.Roleslist}
													val={this.state.RoleId}
													addPlaceholder=""
													loading={this.state.RolesLoader}
													searchBy="roleName"
													labelField="roleName"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>

											<div
												hidden={
													this.state.RoleId === 0 ||
													this.state.RoleId === 4 ||
													this.state.RoleId === 7 ||
													this.state.RoleId === 3 ||
													this.state.RoleId === 6
												}
												className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12"
											>
												<label htmlFor="">
													<span style={{ color: "red" }}>* </span>Province
												</label>
												<DropDown
													multi={true}
													dropdownRenderer={true}
													create={false}
													onChange={this.handleChange}
													Type="SelectedProvince"
													options={this.state.Provincelist}
													val={
														this.state.Id === 0
															? this.state.SelectedProvince
															: this.state.Provincelist
													}
													addPlaceholder=""
													disabled={false}
													loading={this.state.ProvinceLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={true}
													placeholder="Select"
												/>
											</div>
											<div
												hidden={
													this.state.RoleId === 0 ||
													this.state.RoleId === 4 ||
													this.state.RoleId === 7 ||
													this.state.RoleId === 3 ||
													this.state.RoleId === 6
												}
												className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12"
											>
												<label htmlFor="">Sub Recipient</label>
												<DropDown
													multi={true}
													dropdownRenderer={true}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="SrId"
													options={this.state.FilteredSrs}
													val={
														this.state.Id === 0
															? this.state.SrId
															: this.state.SrList
													}
													addPlaceholder=""
													disabled={false}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={true}
													placeholder="Select"
												/>
											</div>

											<div
												class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12"
												hidden={this.state.RoleId !== 6}
											>
												<label for="">
													<span style={{ color: "red" }}>* </span>BHU
												</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="BHUId"
													options={this.state.FilteredBHU}
													val={this.state.BHUId}
													addPlaceholder=""
													// disabled={this.state.Id !== 0}
													loading={this.state.HCFLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>

											<div
												class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12"
												hidden={this.state.RoleId !== 7}
											>
												<label for="">
													<span style={{ color: "red" }}>* </span>RHC
												</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="RHCId"
													options={this.state.FilteredRHC}
													val={this.state.RHCId}
													addPlaceholder=""
													// disabled={this.state.Id !== 0}
													loading={this.state.HCFLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>

											{this.state.RoleId === 3 && (
												<div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
													<label htmlFor="">
														<span style={{ color: "red" }}>* </span> Xpert Site
													</label>
													<DropDown
														multi={false}
														dropdownRenderer={false}
														create={false}
														onChange={this.HandleAutoSuggestValChange}
														Type="XpertSiteId"
														options={this.state.FilteredXpertSites}
														val={this.state.XpertSiteId}
														addPlaceholder=""
														// disabled={this.state.Id !== 0}
														loading={this.state.XpertSiteLoader}
														searchBy="name"
														labelField="name"
														valueField="id"
														contentRenderer={false}
														placeholder="Select"
													/>
												</div>
											)}

											<div
												class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12"
												hidden={this.state.RoleId !== 5}
											>
												<label for="">
													<span style={{ color: "red" }}>* </span>Supervisor's
													District
												</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="DistrictId"
													options={this.state.Districtlist}
													val={this.state.DistrictId}
													addPlaceholder=""
													disabled={
														!(
															this.state.Id === 0 ||
															this.state.saveddistictId === 0 ||
															this.state.saveddistictId === null
														)
													}
													loading={this.state.DistrictLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>

											<div
												class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12"
												hidden={this.state.RoleId !== 5}
											>
												<label for="">
													<span style={{ color: "red" }}>* </span>Supervisor's
													Clusters
												</label>
												<DropDown
													multi={true}
													dropdownRenderer={true}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="ClusterId"
													options={this.state.FilteredClustersList}
													val={this.state.ClusterId}
													addPlaceholder=""
													// disabled={this.state.Id==0 || this.state.savedClusterId=="" || this.state.savedClusterId==null ?false: true}
													loading={this.state.ClusterLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>

											<div
												class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12"
												hidden={this.state.RoleId !== 4}
											>
												<label for="">
													<span style={{ color: "red" }}>* </span>Vehicle Number
												</label>
												<input
													autocomplete="off"
													type="text"
													class="form-control"
													id="VehicleNumber"
													placeholder="Enter user vehicle number"
													required={this.state.RoleId === 4}
												/>
											</div>

											<div
												class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12"
												hidden={this.state.RoleId !== 4}
											>
												<label for="">
													<span style={{ color: "red" }}>* </span>Vehicle Model
												</label>
												<input
													autocomplete="off"
													type="text"
													class="form-control"
													id="VehicleModel"
													placeholder="Enter user vehicle model"
													required={this.state.RoleId === 4}
												/>
											</div>

											

											<div
												class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12"
												hidden={
													this.state.RoleId === 0 ||
													this.state.RoleId === 4 ||
													this.state.RoleId === 7 ||
													this.state.RoleId === 3 ||
													this.state.RoleId === 6
												}
											>
												<label for="">
													<span style={{ color: "red" }}>* </span>Districts
													Allowed To Access data
												</label>
												<DropDown
													multi={true}
													dropdownRenderer={true}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="SRDistrictId"
													options={this.state.FilteredAllowedDistricts}
													val={this.state.SRDistrictId}
													addPlaceholder=""
													disabled={false}
													loading={this.state.DistrictLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={true}
													placeholder="Select"
												/>
											</div>

											<div
												class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12"
												hidden={
													this.state.RoleId === 1 ||
													this.state.RoleId === 13 ||
													this.state.RoleId === 8 ||
													this.state.RoleId === 11 ||
													this.state.RoleId === 14 ||
													this.state.RoleId === 15 ||
													this.state.RoleId === 16
												}
											>
												<label for="">
													<span style={{ color: "red" }}>* </span>
													Bank
												</label>
												<DropDown
													multi={false}
													dropdownRenderer={false}
													create={false}
													onChange={this.HandleAutoSuggestValChange}
													Type="BankId"
													options={this.state.Banklist}
													val={this.state.BankId}
													addPlaceholder=""
													disabled={false}
													loading={this.state.BankLoader}
													searchBy="name"
													labelField="name"
													valueField="id"
													contentRenderer={false}
													placeholder="Select"
												/>
											</div>

											<div
												class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12"
												hidden={
													this.state.RoleId === 1 ||
													this.state.RoleId === 13 ||
													this.state.RoleId === 8 ||
													this.state.RoleId === 11 ||
													this.state.RoleId === 14 ||
													this.state.RoleId === 15 ||
													this.state.RoleId === 16
												}
											>
												<label for="">Account Number</label>
												<input
													autocomplete="off"
													type="text"
													class="form-control"
													id="AccountNumber"
													placeholder="Enter Account Number"
												/>
											</div>

											<div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label>Filing Status</label>
												<select id="filingStatus" className="form-control">
													<option value="0">Non Filer</option>
													<option value="1">Filer</option>
												</select>
											</div>

											<div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label>Gender</label>
												<select id="gender" className="form-control">
													<option value="1">Male</option>
													<option value="2">Female</option>
												</select>
											</div>
											<div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
												<label htmlFor="">CNIC #</label>
												<input
													autoComplete="off"
													type="text"
													className="form-control"
													id="cnic"
													pattern="\d{5}-\d{7}-\d{1}"
													placeholder="Enter CNIC(#####-#######-#)"
												/>
											</div>

											<div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<label for="">Address</label>
												<textarea
													autocomplete="off"
													class="form-control"
													id="UserAddress"
													rows="3"
													placeholder="Enter user address"
												></textarea>
											</div>

											<div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<div class="row">
													<div
														class="custom-control custom-checkbox mb-3"
														onClick={(e) => {
															this.setState({ isActive: true });
														}}
													>
														<input
															type="radio"
															class="custom-control-input"
															name="isActiveRadio"
															checked={this.state.isActive}
														/>
														<label class="custom-control-label">Active</label>
													</div>
													<div
														class="custom-control custom-checkbox mb-3"
														style={{ marginLeft: "15px" }}
														onClick={(e) => {
															this.setState({ isActive: false });
														}}
													>
														<input
															type="radio"
															class="custom-control-input"
															name="isActiveRadio"
															checked={!this.state.isActive}
														/>
														<label class="custom-control-label">InActive</label>
													</div>
												</div>
											</div>

											<div class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<button
													type="submit"
													id="Form_SaveBtn"
													class="btn btn_style1"
													hidden={this.state.Id === this.state.loggedinUser}
												>
													Save
												</button>
												<button
													type="button"
													onClick={this.onDelete}
													id="Form_DeleteBtn"
													class="btn btn_style2"
													hidden={
														this.state.Id === this.state.loggedinUser
															? true
															: this.state.Id === 0
													}
												>
													Delete
												</button>
												<Link to="/Users">
													<button
														type="button"
														id="Form_CancelBtn"
														class="btn btn_style3"
													>
														Cancel
													</button>
												</Link>

												{/* Hide button for reset */}
												<Link style={{ display: "none" }} to="/User_Add">
													<button
														id="Form_ResetBtn"
														type="button"
														class="btn initial-btn Cancel-Form-btn Form_Btn"
													>
														Reset
													</button>
												</Link>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>

						<div
							class="card col-md-4 col-lg-4"
							style={{ padding: "10px", background: "none", boxShadow: "none" }}
						>
							<div class="card-body">
								<label for="">Image</label>
								<div
									className="ImagePlacement_Container"
									style={{ marginTop: "35px" }}
								>
									<img
										class="dopzone-logo"
										src=""
										id="Upload_ImageDropZone"
										style={{ display: "none" }}
									/>
									<span
										class="updateimage-Btn"
										onClick={() => {
											$("#UploadImgBtn").click();
										}}
									>
										<i class="fa fa-plus" aria-hidden="true"></i>
									</span>
									<input type="hidden" id="changedimagekey" />
									<input
										name="file"
										class="col-md-12"
										style={{
											paddingLeft: "0px",
											fontSize: "17px",
											cursor: "pointer",
											display: "none",
										}}
										accept="image/gif,image/jpeg,image/png"
										type="file"
										id="UploadImgBtn"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Users_Add);
